<template>
  <SeoPage page-key="posizionamentoMotoriRicercaLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'PosizionamentoMotoriRicercaLuganoPage'
})
</script>

